import { createPortal } from 'react-dom';
import { useQuery } from '@tanstack/react-query';
import { getIssuesForInspection } from '../../services/IIMIssuesService';
import { iimReviewKeys } from '../../hooks/queryKeys';
import { DEFAULT_ACTIVE_STATUSES } from '../IssuesGrid/types';
const PORTAL_TARGET_ID = 'iim-issue-count-badge';
/**
 * Renders the active issue count (Detected, Skipped, Suggested, Correction Suggested) into the
 * Inspection Assistant tab badge via a React portal. Matches the grid default.
 */
export default function IssueCountBadge({ inspectionId }) {
    const portalTarget = document.getElementById(PORTAL_TARGET_ID);
    const { data: count } = useQuery({
        queryKey: iimReviewKeys.issues(inspectionId, DEFAULT_ACTIVE_STATUSES),
        queryFn: () => getIssuesForInspection(inspectionId, DEFAULT_ACTIVE_STATUSES),
        select: (response) => response.issues.length,
        staleTime: 5 * 60 * 1000,
        cacheTime: 30 * 60 * 1000
    });
    if (!portalTarget || count === undefined)
        return null;
    return createPortal(String(count), portalTarget);
}
